import {Button} from '@repo/shared/Customer/Coop/Button/Button'
import {useWakeLockContext} from '@repo/shared/WakeLockProvider'
import {useEffect} from 'react'

export const ErrorScene = () => {
  const {releaseWakeLock} = useWakeLockContext()

  useEffect(() => {
    releaseWakeLock()
  }, [releaseWakeLock])

  return (
    <div className="fixed inset-0 z-30 flex flex-col items-center justify-center pb-[12vh] pt-[18vh]">
      <div className="flex max-w-[500px] flex-col items-center rounded-[32px] bg-white px-8 py-8">
        <h2 className="mb-8 text-2xl">Et eller annet er galt.. 😱</h2>
        <ul className="mb-4">
          {!navigator?.onLine && (
            <li className="mb-2">
              Det virker ikke som du er koblet til internett. Sjekk tilkoblingen og prøv igjen.
            </li>
          )}

          {navigator?.onLine && (
            <li className="mb-2">
              Det kan være noe feil med serveren – prøv igjen senere eller kontakt support.
            </li>
          )}
        </ul>
        <Button color="purple" size="small" onClick={() => location.replace(location.origin)}>
          Start på nytt
        </Button>
      </div>
    </div>
  )
}
